import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — Peopels" },
      { name: "description", content: "Terms governing your use of the Peopels marketplace platform, operated by Ashers Hub Ltd." },
    ],
    links: [{ rel: "canonical", href: "/terms" }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-3xl flex-1 px-4 py-16 sm:px-6 lg:px-8">
        <article className="prose max-w-none">
          <h1 className="font-display text-4xl font-bold">Terms of Service</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-GB")}</p>

          <h2 className="mt-8 text-xl font-semibold">1. Platform operator</h2>
          <p>
            Peopels is operated by <strong>Ashers Hub Ltd</strong>, a company registered in England and Wales
            under company number <strong>17204476</strong> ("Peopels", "we", "us", "our"). References to "the platform"
            mean the Peopels website, mobile experience and related services provided by Ashers Hub Ltd.
          </p>

          <h2 className="mt-8 text-xl font-semibold">2. The service</h2>
          <p>
            Peopels is a marketplace connecting Customers with independent Professionals ("Helpers" or "Professionals").
            Ashers Hub Ltd is not an employer of Professionals and does not itself provide the services listed; the contract
            for the services is between the Customer and the Professional.
          </p>

          <h2 className="mt-8 text-xl font-semibold">3. Fees</h2>
          <p>
            Professionals are charged a 10% platform fee on the agreed job value; Customers pay a 5% service fee on top.
            Both fees are shown before booking. <strong>Platform and service fees are non-refundable</strong> on cancelled
            bookings except where required by law or expressly stated in our Cancellation Policy.
          </p>

          <h2 className="mt-8 text-xl font-semibold">4. Payments &amp; escrow</h2>
          <p>
            All payments are processed via Stripe. The card is securely authorized at booking, funds are held in
            Stripe escrow, and released to the Professional only when the job is confirmed done. Refunds are issued
            in accordance with the Cancellation Policy.
          </p>

          <h2 className="mt-8 text-xl font-semibold">5. Cancellations</h2>
          <p>
            Once a Professional has accepted a booking, that Professional may begin allocating time, reserving
            availability and travelling to the job location. Cancellation of accepted bookings is therefore governed
            by our <Link to="/cancellation" className="underline">Cancellation Policy</Link>, which forms part of these Terms.
            By submitting a booking you confirm you have read and accepted that policy.
          </p>

          <h2 className="mt-8 text-xl font-semibold">6. Professional obligations</h2>
          <p>
            Professionals operate as independent contractors. Accepting a booking creates obligations to both the
            Customer and the platform. Professionals agree to the additional terms set out in our{" "}
            <Link to="/professional-terms" className="underline">Professional Terms</Link>.
          </p>

          <h2 className="mt-8 text-xl font-semibold">7. Conduct</h2>
          <p>Harassment, fraud, off-platform payment or abusive behaviour will result in account suspension.</p>

          <h2 className="mt-8 text-xl font-semibold">8. Governing law</h2>
          <p>
            These Terms are governed by the laws of England and Wales. Disputes are subject to the exclusive
            jurisdiction of the courts of England and Wales.
          </p>

          <h2 className="mt-8 text-xl font-semibold">9. Contact</h2>
          <p>Ashers Hub Ltd · Company No. 17204476 · legal@peopels.com</p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
